var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var NotificationStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 0px auto;\n  padding: 10px 12px 10px 12px;\n  justify-content: space-between;\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  transition: opacity ", " ease;\n  font-size: 1.4rem;\n  line-height: 1em;\n  font-weight: 600;\n  & > span {\n  }\n  & > button {\n    display: inline-block;\n    margin-left: 8px;\n    position: relative;\n    top: 0.5px;\n    div,\n    svg {\n      width: 12px;\n      height: 12px;\n    }\n  }\n  &.error {\n    color: ", ";\n    background-color: ", ";\n  }\n  &.warning {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  display: inline-block;\n  margin: 0px auto;\n  padding: 10px 12px 10px 12px;\n  justify-content: space-between;\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  transition: opacity ", " ease;\n  font-size: 1.4rem;\n  line-height: 1em;\n  font-weight: 600;\n  & > span {\n  }\n  & > button {\n    display: inline-block;\n    margin-left: 8px;\n    position: relative;\n    top: 0.5px;\n    div,\n    svg {\n      width: 12px;\n      height: 12px;\n    }\n  }\n  &.error {\n    color: ", ";\n    background-color: ", ";\n  }\n  &.warning {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.normal.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.normal.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.error.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.error.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.warning.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.warning.color;
});
var templateObject_1;
//# sourceMappingURL=NotificationStyled.js.map